import { render, staticRenderFns } from "./add-file-form.vue?vue&type=template&id=ca461ae2&scoped=true"
import script from "./add-file-form.vue?vue&type=script&lang=js"
export * from "./add-file-form.vue?vue&type=script&lang=js"
import style0 from "./add-file-form.vue?vue&type=style&index=0&id=ca461ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca461ae2",
  null
  
)

export default component.exports